const navMugicsSVG = `
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="66.363px" height="85.368px" viewBox="0 0 66.363 85.368" enable-background="new 0 0 66.363 85.368" xml:space="preserve">
<g id="Layer_1">
	<g>
		<g>
			<path fill="#6A5DA8" d="M54.107,46.398c2.072-3.781,3.211-8.305,3.211-13.314c0,0-0.098-27.139-0.242-27.445
				C56.629,2.336,53.934,0,50.576,0c-3.676,0-6.697,2.615-6.863,6.225c-0.027,0.166-0.51,27.32-0.51,27.32
				c0,7.24-3.574,12.174-10.354,12.174c-6.777,0-10.566-4.934-10.566-12.174c0,0,0.016-27.586-0.123-27.889
				C21.719,2.346,19.074,0,15.713,0c-3.627,0-6.568,2.551-6.801,6.084c-0.045,0.205-0.48,27-0.48,27c0,5.117,1.6,9.723,3.756,13.553
				C4.592,49.459,0,56.305,0,65.217c0,11.912,8.822,20.151,20.863,20.151h24.842c12.039,0,20.658-8.368,20.658-20.405
				C66.363,56.204,61.611,49.387,54.107,46.398z"/>
			<g>
				<path fill="#FFFFFF" d="M56.496,64.768c0,5.988-4.855,10.84-10.838,10.84H20.836c-5.986,0-10.842-4.852-10.842-10.84l0,0
					c0-5.988,4.855-10.84,10.842-10.84h24.822C51.641,53.928,56.496,58.779,56.496,64.768L56.496,64.768z"/>
				<polygon fill="#08FCC9" points="30.615,59.295 21.363,59.295 25.99,43.106 7.488,68.548 16.74,68.548 12.113,84.739 				"/>
				<path fill="#221F1F" d="M22,65.549c0,1.623-1.322,2.945-2.947,2.945l0,0c-1.629,0-2.949-1.322-2.949-2.945v-3.25
					c0-1.627,1.32-2.947,2.949-2.947l0,0c1.625,0,2.947,1.32,2.947,2.947V65.549z"/>
				<path fill="#221F1F" d="M50.854,65.344c0,1.625-1.32,2.947-2.949,2.947l0,0c-1.629,0-2.947-1.322-2.947-2.947v-3.25
					c0-1.625,1.318-2.945,2.947-2.945l0,0c1.629,0,2.949,1.32,2.949,2.945V65.344z"/>
			</g>
		</g>
	</g>
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids" display="none">
</g>
</svg>

`;

export default navMugicsSVG;



// WEBPACK FOOTER //
// ./src/Components/Modals/Navigation/images/navMugicsSVG.js